const web = require('./webPush');
const native = require('./nativePush');
const isNative = () => typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
module.exports = {
  pushStatus: (...args) => isNative() ? native.nativePushStatus(...args) : web.pushStatus(...args),
  enableWebPush: (...args) => isNative() ? native.enableNativePush(...args) : web.enableWebPush(...args),
  disableWebPush: (...args) => isNative() ? native.disableNativePush(...args) : web.disableWebPush(...args),
  pushPreferences: web.pushPreferences, savePushPreferences: web.savePushPreferences
};
